import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'
import store from '@/store'

export default {
  resetRecommendation({ commit }) {
    commit(types.RESET_RECOMMENDATION)
  },
  resetTranslations({ commit }) {
    commit(types.RESET_TRANSLATIONS)
  },
  setCriteriaChanged({ commit }, value) {
    commit(types.SET_CRITERIA_CHANGED, value)
  },
  async setStep({ commit, state, dispatch }, value) {
    if (value !== 99) {
      commit(types.SET_STEP, value)
      commit(types.SET_VISITED_STEP, value)
    }
    if (state.criteriaChanged) {
      // if anything was changed, save the Scan Pro Criteria
      let profile = store.getters['auth/profile']
      let data = {
        businessId: profile.location.Id,
        criteria: state.scanProCriteria,
        checklist: state.scanProChecklist
      }
      await startLoading(dispatch, 'saveScanProConfiguration', () => http.post('scanpro/SaveScanProConfiguration', data))
      commit(types.SET_CRITERIA_CHANGED, false)
    }
  },
  resetVisitedStep({ commit }, value) {
    commit(types.RESET_VISITED_STEP, value)
  },
  updateBmsRepairs({ commit }, value) {
    commit(types.UPDATE_BMS_REPAIRS, value)
  },
  updateRecommendation({ commit }, data) {
    commit(types.UPDATE_RECOMMENDATION, data)
  },
  prepRecommendation({ commit }, firm) {
    commit(types.PREP_RECOMMENDATION, firm)
  },
  async getRecommendations({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getRecommendations', () => http.get(`calibrate/calibrateRecommendations?firm=${firm}`))
    commit(types.SET_RECOMMENDATIONS, r.data)
    return r.data
  },
  async getRecommendation({ commit, dispatch }, calibrateRecommendation) {
    const r = await startLoading(dispatch, 'getRecommendation', () => http.get(`calibrate/calibrateRecommendation?calibrateRecommendation=${calibrateRecommendation}`))
    commit(types.SET_RECOMMENDATION, r.data)
    return r.data
  },
  async saveRecommendation({ dispatch, state }) {
    const r = await startLoading(dispatch, 'saveRecommendation', () =>
      http.post('calibrate/saveCalibrateRecommendation', {
        firm: state.recommendation.firm,
        calibrateRecommendation: state.recommendation.calibrateRecommendation,
        recommendation: state.recommendation.recommendation,
        calibrateType: state.recommendation.calibrateType,
        vehicleMake: state.recommendation.vehicleMake,
        recommendationText: state.recommendation.recommendationText
      })
    )
    return r.data
  },
  async deleteRecommendation({ dispatch }, calibrateRecommendation) {
    const r = await startLoading(dispatch, 'deleteRecommendation', () => http.get(`calibrate/deleteCalibrateRecommendation?calibrateRecommendation=${calibrateRecommendation}`))
    return r.data
  },
  async saveNewTranslation({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveNewTranslation', () => http.post('language/addTranslation', data))
    return r.data
  },
  async saveTranslation({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTranslation', () => http.post('language/saveTranslation', data))
    return r.data
  },
  async getTranslations({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getTranslations', () => http.get(`language/translations?translationType=${data.translationType}&languageCode=${data.languageCode}`))
    commit(types.SET_TRANSLATIONS, r.data)
    return r.data
  },
  async deleteTranslation({ dispatch }, translation) {
    const r = await startLoading(dispatch, 'deleteTranslation', () => http.get(`language/deleteTranslation?translation=${translation}`))
    return r.data
  },
  async getBmsRepairs({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getBmsRepairs', () => http.get('bms/repairs'))
    commit(types.SET_BMS_REPAIRS, r.data)
    return r.data
  },
  async putBmsRepair({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'putBmsRepair', () => http.get(`bms/repairBMS?repairData=${data.repairData}&repairFacilityId=${data.cccId}`))
    commit(types.SET_BMS_XML, r.data)
    return r.data
  },
  async saveBms({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveBms', () => http.post('bms/estimate', data))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/actions.js